import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100 grid place-items-center px-4 grid-bg">
      <div className="bg-[#0F172A] border border-slate-800 rounded-3xl p-10 max-w-md w-full text-center" data-testid="payment-cancel-card">
        <div className="w-16 h-16 rounded-2xl bg-slate-700/40 border border-slate-700 grid place-items-center mx-auto">
          <XCircle className="w-9 h-9 text-slate-400" />
        </div>
        <h1 className="font-display text-2xl font-bold mt-5">Checkout cancelled</h1>
        <p className="text-slate-400 text-sm mt-2">No worries — you can still learn with the Free plan or upgrade to Pro anytime.</p>
        <div className="flex gap-3 mt-6">
          <button onClick={() => navigate("/choose-plan")} className="flex-1 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-xl py-3 transition-colors">Back to plans</button>
          <button onClick={() => navigate("/choose-plan")} data-testid="retry-pro-btn" className="flex-1 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl py-3 transition-colors">Try again</button>
        </div>
      </div>
    </div>
  );
}
